module.exports = __webpack_public_path__ + "static/img/mapSwitch.484e4ff8.png";